var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 29.9565C14.0802 31.5969 15.4223 34.4302 19.0012 34.4302C20.7907 34.4302 24.0118 33.8934 24.3697 29.9565",
    stroke: "#8A96A3",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 29.0601H36",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0779 28.6136V14.0664C31.0779 13.9228 31.0655 13.7763 31.0389 13.6352C29.5199 5.58825 22.3987 3.86067 18.999 4.00848C15.6096 4.00854 8.43379 5.93093 6.53819 13.5747C6.49332 13.7557 6.47266 13.9447 6.47266 14.1311V28.6136",
    stroke: "#8A96A3",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.cddc5150764b97fab9672ab02427f951.svg";
export { ForwardRef as ReactComponent };